export default function NoResultsMessage() {
  return (
    <div className="no-results-message">
      <h2>No games found</h2>
      <p>
        We couldn&apos;t find any games matching your search and filters. Try a
        different title, removing some filters, or resetting the search.
      </p>
    </div>
  );
}
